/* ── GetCovered V6 Design Tokens ── */

export const C = {
  bg: "#F0F4F9",
  surface: "#FFFFFF",
  surfaceMid: "#F8FAFC",
  border: "#E2E8F0",
  textMuted: "#6B7280",
  textMid: "#374151",
  navy: "#0D1B35",
  navyMid: "#1E3A5F",
  navyLight: "#E8EFF8",
  blue: "#1565C0",
  blueDark: "#0D47A1",
  blueLight: "#E3EFFE",
  ok: "#16A34A",
  okLight: "#F0FDF4",
  bad: "#DC2626",
  badLight: "#FEF2F2",
  warn: "#D97706",
  warnLight: "#FFFBEB",
};

export const card = (extras = {}) => ({
  background: C.surface,
  border: `1px solid ${C.border}`,
  borderRadius: 18,
  boxShadow: "0 1px 4px rgba(13,27,53,0.06)",
  ...extras,
});

export const PILLAR_COLORS = {
  insurance: { bg: "#E6F1FB", border: "#266ab3", text: "#0C447C", icon: "\u{1F6E1}\uFE0F" },
  retirement: { bg: "#E1F5EE", border: "#0F6E56", text: "#085041", icon: "\u{1F4CA}" },
  financial: { bg: "#FAEEDA", border: "#BA7517", text: "#633806", icon: "\u{1F4B3}" },
  estate: { bg: "#FAECE7", border: "#993C1D", text: "#712B13", icon: "\u{1F3DB}\uFE0F" },
};

export const PILLARS = [
  {
    key: "insurance",
    label: "Insurance",
    icon: "\u{1F6E1}\uFE0F",
    tools: [
      { name: "Get a Quote", route: "/quote", desc: "Compare real premiums from 8 carriers" },
      { name: "Insurance Explorer", route: "/insurance-explorer", desc: "Find the right coverage for you" },
      { name: "My Quotes", route: "/panel", desc: "View submitted quotes" },
      { name: "My Policies", route: "/my-policies", desc: "Track existing coverage" },
    ],
  },
  {
    key: "retirement",
    label: "Retirement",
    icon: "\u{1F4CA}",
    tools: [
      { name: "Investor Profile", route: "/investor-profile", desc: "5 risk profiles, FP Canada KYC" },
      { name: "Retirement Planner", route: "/retirement-planner", desc: "3 scenarios, PAG 2025 rates" },
    ],
  },
  {
    key: "financial",
    label: "Financial",
    icon: "\u{1F4B3}",
    tools: [
      { name: "Health Checkup", route: "/health-score", desc: "Your 0-850 Awareness Score" },
      { name: "Balance Sheet", route: "/balance-sheet", desc: "Assets vs liabilities" },
      { name: "Cash Flow", route: "/cash-flow", desc: "Income vs expenses" },
      { name: "Debt Planner", route: "/debt-planner", desc: "Avalanche vs snowball" },
    ],
  },
  {
    key: "estate",
    label: "Estate",
    icon: "\u{1F3DB}\uFE0F",
    tools: [
      { name: "Estate Readiness", route: "/estate-planner", desc: "Check your estate preparation" },
      { name: "Estate Cost Calculator", route: "/estate-cost", desc: "See what your estate would cost" },
      { name: "Will Checklist", route: "/will-checklist", desc: "Essential documents review" },
    ],
  },
];
